import { Amplify } from "aws-amplify";

import * as AuthWrapper from "./auth";
import * as StorageWrapper from "./storage";

import type { ResourcesConfig } from "aws-amplify";

const awsExports = {
	Auth: {
		Cognito: {
			// region: import.meta.env.VITE_AUTH_REGION,
			userPoolId: import.meta.env.VITE_AUTH_USER_POOL_ID,
			userPoolClientId: import.meta.env.VITE_AUTH_USER_POOL_WEB_CLIENT_ID,
			identityPoolId: import.meta.env.VITE_AUTH_IDENTITY_POOL_ID,
		},
	},
	Storage: {
		S3: {
			bucket: import.meta.env.VITE_STORAGE_AWSS3_BUCKET,
			region: import.meta.env.VITE_STORAGE_AWSS3_REGION,
			// baseUrl: import.meta.env.VITE_STORAGE_AWSS3_BASE_URL,
			// masterBaseUrl: import.meta.env.VITE_STORAGE_AWSS3_MASTER_BASE_URL,
		},
	},
} satisfies ResourcesConfig;

const amplifyInit = () => {
	Amplify.configure(awsExports);
};

export {
	AuthWrapper, //
	StorageWrapper,
	amplifyInit,
};
